import { delay, put, select, takeLatest } from 'redux-saga/effects';
import axios from 'axios';

import objectToSnakeCase from 'utils/objectToSnakeCase';
import { HttpStatusCodes } from 'utils/constants';
import { formatMessage } from 'utils/intlOutsideReact';

import { verificationCodeError, verificationCodeSuccess } from '../actions';
import { VERIFICATION_CODE_REQUEST } from '../constants';
import { makeSelectLoginFormData } from '../selectors';
import messages from '../messages';

function* verifyCode({ payload: { verificationCode, rememberBrowser } }) {
  const requestURL = `/v1/users/confirm_logging_code`;

  const { email } = yield select(makeSelectLoginFormData());

  try {
    const {
      // eslint-disable-next-line camelcase
      data: { verification_code },
    } = yield axios.patch(
      requestURL,
      objectToSnakeCase({ verificationCode, email, rememberBrowser }),
      {
        headers: { Uid: email },
        withCredentials: true,
      },
    );

    yield delay(300);
    // eslint-disable-next-line camelcase
    const codeForState = rememberBrowser ? null : verification_code;
    yield put(verificationCodeSuccess(codeForState));
  } catch (error) {
    yield delay(300);

    switch (error.response.status) {
      case HttpStatusCodes.NOT_FOUND:
        yield put(
          verificationCodeError(
            formatMessage(messages.codeVerification404Error),
          ),
        );
        break;

      case HttpStatusCodes.REQUEST_TIMEOUT:
        yield put(
          verificationCodeError(
            formatMessage(messages.codeVerification408Error),
          ),
        );
        break;

      default:
        yield put(verificationCodeError(error));
        break;
    }
  }
}

export default function* verifyCodeSaga() {
  yield takeLatest(VERIFICATION_CODE_REQUEST, verifyCode);
}
